import {charcoal} from '../sass/base/_exports.sass';

export const PostStampIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 24;
  const height = 24;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={style}
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="24" height="24" fill="url(#postStamp)" />
      <defs>
        <pattern id="postStamp" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_2292_47024" transform="scale(0.0104167)" />
        </pattern>
        <image
          id="image0_2292_47024"
          width="96"
          height="96"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAABG0lEQVR4nO3dQQ6CMBRAQTTe/8q6Z2HSUHihzBygIi+A8BPZNgAA4GleJ6z5nbwNo+udvf7UffaeuRjjBIgJEJtxPjt6jr67Q/vQERATICZATICYADEBYgLEPsFnnvH8aaZL72scATEBYgLEZlwD9uf01Z8NmQesRICYADEBYgLEBIgJEJtxH7D67/69/fc1E74zAWICxASICRATICZATICYADEBYgLEzITHmQmvRICYADEBYgLEBIgJEDMTHmcmvBIBYgLEBIgJEBMgJkBMgJgAMQFiAsTMhMeZCa9EgJgAMQFiAsQEiAkQMxMeZya8EgFiAsSK/w192jXjL0dATICYADEBYgLEBIgJEPMuSe+SfDYBYgIAAABc7AdEkBKtrp2C1QAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>
  );
};
